<script setup lang="ts">
import { onClickOutside } from "@vueuse/core";
import { useTemplateRef } from "vue";

const { closeAll } = useNavigation();

const dropdown = useTemplateRef<HTMLElement>("dropdown");

onClickOutside(dropdown, () => closeAll());
</script>

<template>
  <div ref="dropdown" class="dropdown">
    <slot />
  </div>
</template>

<style scoped lang="scss">
.dropdown {
  position: absolute;
  background-color: var(--primary-white, #ffffff);
  top: calc(var(--header-navigation-height, 60px) - 5px);
  right: 0;
  padding: 20px 40px;
  box-shadow: var(--shadow-dropper, 0 2px 4px rgba(0, 0, 0, 0.5));
}
</style>
